import React from "react";
import "./index.css";
import Container from "../../../Components/General/Container";

// Figma node 11853:9161 — the stat row that sits directly under the hero.
const stats = [
  { value: "₹120 crore", label: "Funded" },
  { value: "4.5 ⭐️", label: "Glassdoor Rating" },
  { value: "2x", label: "YoY Growth" },
  { value: "120+", label: "Member Strong, 6 Cities" },
];

function DrivenByResults() {
  return (
    <div className="drivenSectionWrap animated-section section">
      <Container>
        <div className="row">
          <div className="col-lg-12 aosAnim">
            <h2 className="drivenTitle">
              <span className="gradientText">Driven</span> by results,
              <br />
              powered by people
            </h2>
            <div className="drivenStatRow">
              {stats.map((stat) => (
                <div className="drivenStatCard" key={stat.label}>
                  <strong className="drivenStatValue">{stat.value}</strong>
                  <span className="drivenStatLabel">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default DrivenByResults;
